import React from "react";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import imagen1 from "../../assets/guias_implementacion/IconosInterior/Group-5.png"

const StepMenuGuiaMagento = ({ handleScrollTo, pasoActivo, setPasoActivo }) => {
  const pasos = [
    "Introducción",
    "Explicación"
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        position: "fixed",
        width: "170px",
        transform: {
          xs: 'scale(0.6)',
          md: 'none',
        }
      }}
    >
      {/* Encabezado WordPress */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "left",
          gap: "8px",
          backgroundColor: "#E7F0FF",
          padding: "6px 12px",
          borderRadius: "20px",
          marginBottom: "12px",
          width: {xs: '82%', md: "100%"},
        }}
      >
        <img
          src={imagen1}
          alt="Logo Magento"
          width="20"
          height="20"
        />
        <Typography sx={{ color: "#0F52BD" }}>
          Magento
        </Typography>
      </Box>

      {/* Contenedor con línea segmentada y lista de pasos */}
      <Box sx={{ display: "flex", ml: 3 }}>
        {/* Línea vertical segmentada */}
        <Box sx={{ display: "flex", flexDirection: "column", marginRight: "8px", mt: 1 }}>
          {pasos.map((paso, index) => (
            <Box
              key={index}
              sx={{
                width: "3px",
                height: "45px",
                backgroundColor: paso === pasoActivo ? "#1a73e8" : "#ccc",
                borderRadius: "1px",
              }}
            />
          ))}
        </Box>

        {/* Lista de pasos */}
        <List>
          {pasos.map((paso, index) => (
            <ListItemButton
              key={index}
              onClick={() => {
                setPasoActivo(paso);
                handleScrollTo(index);
              }}
              selected={paso === pasoActivo}
              sx={{
                px: 0,
                py: 1,
                justifyContent: "flex-start",
                textAlign: "left",
                color: paso === pasoActivo ? "#1a73e8" : "#555",
                fontWeight: paso === pasoActivo ? "bold" : "normal",
                backgroundColor: "transparent",
                '&.Mui-selected': {
                  backgroundColor: "transparent",
                },
                '&.Mui-selected:hover': {
                  backgroundColor: "#f5f5f5",
                },
              }}
            >
              <ListItemText
                primary={paso}
                primaryTypographyProps={{
                  fontSize: 14,
                }}
              />
            </ListItemButton>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default StepMenuGuiaMagento;
